import {use} from 'react'
import ChartCardContext from './context'

export interface LeadingVisualProps {
  children: React.ReactNode
}

const LeadingVisual = ({children}: LeadingVisualProps) => {
  const {size} = use(ChartCardContext)
  return size !== 'sparkline' ? <>{children}</> : null
}

export default LeadingVisual

try{ LeadingVisual.displayName ||= 'LeadingVisual' } catch {}